import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { HttpClient } from '@angular/common/http'
import { DashboardService } from './../../dashboard.service'
import { UntypedFormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { Department } from './../../../models/department.model'
import { Observable, Subscription } from 'rxjs';
import { AdminLanguageService } from '../../services/admin-language-service/admin-language.service';
import { Trainer } from 'src/app/models/trainer.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import {LocalStorageService} from '../../services/localStorage-service/local-storage.service';



@Component({
    selector: 'app-insert-folder-dialog',
    templateUrl: './insert-dialog.component.html',
    styleUrls: ['./insert-dialog.component.scss'],
    standalone: false
})
export class InsertDialogComponent implements OnInit {

  nameControl = new UntypedFormControl('', [Validators.required]);
  desControl = new UntypedFormControl('', [Validators.required]);
  err: boolean = false;
  @ViewChild('insertForm') insertForm: NgForm

  labels;
  labelsSub: Subscription;
  selectedImage: File = null
  trainers: Trainer[]
  duration: Number = 0
  uploading: boolean = false
  constructor(private router: Router, public snackBar: MatSnackBar, public dialogRef: MatDialogRef<InsertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data, private dashboardService: DashboardService, private localStorageService: LocalStorageService, public adminLanguageService: AdminLanguageService, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.err = false;
    this.labelsSub = this.adminLanguageService.labels$.subscribe((labels) => {
      this.labels = labels;
    })
  }

   async onSubmit() {
    if (this.insertForm.value.name == "") {
      this.err = true;
      this.snackBar.open(this.labels.lblAllfieldsError, 'OK', {
        verticalPosition: 'top',
        horizontalPosition: 'end',
        duration: 5000
      })
    } else {

      let data = {
        name: this.insertForm.value.name,
        id: this.data.folderId
      }

      if(this.data.folderId == null) {
        this.dashboardService.addNewTrainingFolder(data).subscribe((response) => {
          this.dialogRef.close()
        })
      } else {
        this.dashboardService.addNewTrainingSubfolder(data).subscribe((response) => {
          this.dialogRef.close()
        })
      }
    }
  }
  onNoClick() {
    this.dialogRef.close()
  }

}
